var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.customClass.join(' '),style:(_vm.style)},_vm._l((_vm.data.contents),function(content,index){return _c(("flex-" + (content.type)),{key:index,tag:"component",attrs:{"data":content},on:{"action":_vm.onAction}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }